var map = {
	"./game-intro-01.png": 40851,
	"./game-intro-02.png": 23225,
	"./game-intro-03.png": 68415,
	"./game-intro-04.png": 37963,
	"./game-intro-05.png": 8808,
	"./game-intro-06.png": 70217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65649;